import c from "../common";

export default {
  title: c.takeaway.en.uppercase,
  description_1: "Order",
  description_2: "Menu",
  description_3: "Setting",

  mon: c.weekday.mon.en.uppercase,
  tue: c.weekday.tue.en.uppercase,
  wed: c.weekday.wed.en.uppercase,
  thu: c.weekday.thu.en.uppercase,
  fri: c.weekday.fri.en.uppercase,
  sat: c.weekday.sat.en.uppercase,
  sun: c.weekday.sun.en.uppercase,

  message_1: "Please fill in the Quota",
  message_2: "Please put at least one description",
  message_3: "Please fill in drink's name",
  message_4: "Please indicate drink's price",
  message_5: "Cannot have duplicate drink's name",
  message_6: "Cut all order",
  message_7: "Last Update:",
  message_8: "Current Number:",
  message_9: "Ordered",
  message_10: "Collected",
  message_11: "Drinks:",
  message_12: "",
  message_13: "th meal",
  message_14: "No Drinks",
  message_15: "Remark:",
  message_16: "Choose takeaway voucher",
  message_17: "'s Menu",
  message_18: "+ Add Meal",
  messaeg_19: "Maximum {{max}} selection",
  message_20: "Add/Edit Meal",
  message_21: "Photo",
  message_22: "Each option pair with a photo",
  message_23: "Quota",
  message_24: "Food description",
  message_25: "Cannot add more",
  message_26: "+ Add",
  message_27: "Please Choose",
  message_28: "Hot Only",
  message_29: "Cold Only",
  message_30: "Both Hot & Cold",
  message_31: "Cancel Cut Order",
  message_32: "Cut Order",
  message_33: "Edit",
  message_34: "Qty Left:",
  message_35: "No Takeaway Services",
  message_36: " To ",
  message_37: "Name",
  message_38: "Price",


  open: "Open",
  close: "Close",
  reset: "Reset",
  today: "Today",
  past: "Before",
  na: "No Data",
  confirm: "Confirm",
  save: "Save",
  copy: "Copy",
  paste: "Paste",
  
};
